<div *ngIf="!isIntercollAustralianVersion()" [ngSwitch]="true">
    <div *ngSwitchCase="type === 'fullpaymark' || type === 'fullnab' || type === 'fullmw'">
        <div class="row">
            <div class="col-12 col-md-4">
                <h1>Thank you.</h1>
                <app-send-payment-receipt *ngIf="isEmailReceiptVisible()" [receiptId]="receiptId">
                </app-send-payment-receipt>
                <p>If you've paid your balance in full today we'll update your credit report shortly (If paid by online).</p>
                <p>If you've made a part payment towards your balance/s please set up a payment plan for the balance or visit us again soon to pay the balance. We look forward to updating your credit report soon.</p>
                <p><b>Contact information:</b><br>Hours: Monday - Friday, 8:00am - 8:00pm<br>Phone: <a href="tel:0800683738">0800 683 738</a> or <a href="tel:+6498277701">+64 (9) 827 7701</a><br>Phone: <a href="tel:1800286083">1800 286 083</a> (from Australia)<br>Email: <a href="mailto:customer@debtmanagers.co.nz">customer@debtmanagers.co.nz</a><br><a href="https://www.debtmanagers.co.nz">www.debtmanagers.co.nz</a></p>
            </div>
        </div>
    </div>
    <div *ngSwitchCase="type === 'arrangementpaymark' || type === 'arrangementdirectdebit' || type === 'arrangementnab' || type === 'arrangementmw'">
        <div class="row">
            <div class="col-12 col-md-4">
                <h1>Thank you.</h1>
                <p>You have now taken a step in the right direction.</p>
                <p>If changes are required to your payment plan please contact us.</p>
                <p>Hours: Monday - Friday, 8:00am - 8:00pm<br>Phone: <a href="tel:0800683738">0800 683 738</a> or <a href="tel:+6498277701">+64 (9) 827 7701</a><br>Phone: <a href="tel:1800286083">1800 286 083</a> (from Australia)<br>Email: <a href="mailto:customer@debtmanagers.co.nz">customer@debtmanagers.co.nz</a><br><a href="https://www.debtmanagers.co.nz">www.debtmanagers.co.nz</a></p>
            </div>
        </div>
    </div>
    <div *ngSwitchCase="type === 'arrangementmanualnz' || type === 'arrangementmanualau' || type === 'arrangementbpayau'">
        <div class="row">
            <div class="col-12 col-md-4">
                <h1>Thank you.</h1>
                <p>You're almost there..</p>
                <p>
                    Please log in to your bank and arrange the payment now while it's fresh on your mind.<br>
                </p>
                <div class="d-flex flex-wrap mb-4">
                    <div *ngFor="let bank of getBankList()" class="w-100">
                        <a [href]="bank.url" target="_blank">{{bank.name}}</a>
                    </div>
                    <div *ngIf="isSearchLinkVisible()">Not with one of these banks? Seach my bank <a target="_blank" [href]="getSearchLink()">here</a>.</div>
                </div>
                <p>If changes are required to your payment/s please contact us.</p>
                <p>Hours: Monday - Friday, 8:00am - 8:00pm<br>Phone: <a href="tel:0800683738">0800 683 738</a> or <a href="tel:+6498277701">+64 (9) 827 7701</a><br>Phone: <a href="tel:1800286083">1800 286 083</a> (from Australia)<br>Email: <a href="mailto:customer@debtmanagers.co.nz">customer@debtmanagers.co.nz</a><br><a href="https://www.debtmanagers.co.nz">www.debtmanagers.co.nz</a></p>
            </div>
        </div>
    </div>
</div>

<div *ngIf="isIntercollAustralianVersion()" [ngSwitch]="true">
    <div *ngSwitchCase="type === 'fullpaymark' || type === 'fullnab' || type === 'fullmw'">
        <div class="row">
            <div class="col-12 col-md-4">
                <h1>Thank you.</h1>
                <app-send-payment-receipt *ngIf="isEmailReceiptVisible()" [receiptId]="receiptId">
                </app-send-payment-receipt>
                <p>If you've paid your balance in full today we'll update your credit report shortly (If paid by online).</p>
                <p>If you've made a part payment towards your balance/s please set up a payment plan for the balance or visit us again soon to pay the balance. We look forward to updating your credit report soon.</p>
                <p><b>Contact information:</b><br>Hours: Monday - Friday, 8:00am - 8:00pm<br>Phone: <a href="tel:1800218774">1800 218 774</a><br>Email: <a href="mailto:hello@debtmanagers.com.au">hello@debtmanagers.com.au</a><br><a href="https://www.debtmanagers.com.au">www.debtmanagers.com.au</a></p>
            </div>
        </div>
    </div>
    <div *ngSwitchCase="type === 'arrangementpaymark' || type === 'arrangementdirectdebit' || type === 'arrangementnab' || type === 'arrangementmw'">
        <div class="row">
            <div class="col-12 col-md-4">
                <h1>Thank you.</h1>
                <p>You have now taken a step in the right direction.</p>
                <p>If changes are required to your payment plan please contact us.</p>
                <p>Hours: Monday - Friday, 8:00am - 8:00pm<br>Phone: <a href="tel:1800218774">1800 218 774</a><br>Email: <a href="mailto:hello@debtmanagers.com.au">hello@debtmanagers.com.au</a><br><a href="https://www.debtmanagers.com.au">www.debtmanagers.com.au</a></p>
            </div>
        </div>
    </div>
    <div *ngSwitchCase="type === 'arrangementmanualnz' || type === 'arrangementmanualau' || type === 'arrangementbpayau'">
        <div class="row">
            <div class="col-12 col-md-4">
                <h1>Thank you.</h1>
                <p>You're almost there..</p>
                <p>
                    Please log in to your bank and arrange the payment now while it's fresh on your mind.<br>
                </p>
                <div class="d-flex flex-wrap mb-4">
                    <div *ngFor="let bank of getBankList()" class="w-100">
                        <a [href]="bank.url" target="_blank">{{bank.name}}</a>
                    </div>
                    <div *ngIf="isSearchLinkVisible()">Not with one of these banks? Seach my bank <a target="_blank" [href]="getSearchLink()">here</a>.</div>
                </div>
                <p>If changes are required to your payment/s please contact us.</p>
                <p>Hours: Monday - Friday, 8:00am - 8:00pm<br>Phone: <a href="tel:1800218774">1800 218 774</a><br>Email: <a href="mailto:hello@debtmanagers.com.au">hello@debtmanagers.com.au</a><br><a href="https://www.debtmanagers.com.au">www.debtmanagers.com.au</a></p>
            </div>
        </div>
    </div>
</div>
